/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as interactions from "../interactions/index.js";
import { GoogleGenAiError } from "./google-gen-ai-error.js";

/**
 * Error creating interaction
 */
export type CreateInteractionServerErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error creating interaction
 */
export class CreateInteractionServerError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: CreateInteractionServerErrorData;

  constructor(
    err: CreateInteractionServerErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "CreateInteractionServerError";
  }
}

/**
 * Error creating interaction
 */
export type CreateInteractionClientErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error creating interaction
 */
export class CreateInteractionClientError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: CreateInteractionClientErrorData;

  constructor(
    err: CreateInteractionClientErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "CreateInteractionClientError";
  }
}
